import { ArtifactSourceData, GenericArtifactSourceHolder } from '@/components/canvas/CanvasElementSourceProviders/GenericArtifactFactory'
import { SourceProviderFactory } from '@/components/canvas/CanvasElementSourceProviders/SourceProviderFactory'
import { Camera } from '@/types/Cameras'

export class LTESourceHolder extends GenericArtifactSourceHolder<ArtifactSourceData> {
  readonly artifactType = 'longTimeExposure'
}

export class LTESourceProviderFactory extends SourceProviderFactory<LTESourceHolder> {
  readonly providerType = 'artifact.longTimeExposure'

  createSourceHolder(cameraId: string, timestamp: number, camera: Camera): LTESourceHolder {
    return new LTESourceHolder(cameraId, timestamp, camera)
  }
}
